import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";


export function GraticuleTable({ graticuleStack }) {

    const [workableStack, setWorkableStack] = useState(undefined);

    const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
            const value = obj.properties[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

    useEffect(() => {
        const groupById = groupBy('primary_no')
        if (graticuleStack.features.length > 0) {
            setWorkableStack(groupById(graticuleStack.features));
        } else {
            setWorkableStack(undefined)
        }

        

    }, [graticuleStack])


    const getGraticuleTable = (stack) => {
        let content = [];
        for (const col in stack) {
            content.push(<tr>
                <td>{col}</td>
                <td>{stack[col] ? stack[col].map(e => e.properties.block_no).join(',') : ''}</td>
            </tr>)

        }
        return content;
    }

    return <Table striped bordered >
        <thead>
            <tr>
                <th>Graticule number</th>
                <th>Graticular Block(s)</th>
            </tr>
        </thead>
        <tbody>
            {getGraticuleTable(workableStack)}
            {workableStack===undefined ? 
            
            <tr>
                <td><strong style={{color:'red'}}>Select Graticule(s)</strong></td>
            </tr>
            
            : ""}
        </tbody>
        

    </Table>
}